import { render, staticRenderFns } from "./BankAccountWrapper.vue?vue&type=template&id=b414b57a&scoped=true&"
import script from "./BankAccountWrapper.vue?vue&type=script&lang=ts&"
export * from "./BankAccountWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountWrapper.vue?vue&type=style&index=0&id=b414b57a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b414b57a",
  null
  
)

export default component.exports